import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { 
  FaChartLine, 
  FaShoppingCart, 
  FaSync, 
  FaBullhorn,
  FaCode, 
  FaMobileAlt, 
  FaRobot,
  FaChevronDown,
  FaStar,
  FaCalendarAlt,
  FaArrowRight,
  FaVideo
} from 'react-icons/fa';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (!isMenuOpen) {
      setIsServicesOpen(false);
    }
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsServicesOpen(false);
  };

  const toggleServices = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsServicesOpen(!isServicesOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen && !event.target.closest('.etef-nav-menu') && !event.target.closest('.etef-burger-menu')) {
        closeMenu();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <header className="etef-main-header">
      <div className="etef-header-container">
        <div className="etef-logo-container">
          <Link to="/" className="etef-logo-link" onClick={closeMenu}>
            <img 
              src="/images/logoetefsimple.png" 
              alt="ETEF Design" 
              className="etef-logo-image"
            />
          </Link>
        </div>
        
        <div className={`etef-burger-menu ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
          <div className="etef-burger-line"></div>
          <div className="etef-burger-line"></div>
          <div className="etef-burger-line"></div>
        </div>
        
        <nav className={`etef-nav-menu ${isMenuOpen ? 'mobile-open' : ''}`}>
          <ul className="etef-nav-list">
            <li className="etef-nav-item">
              <Link to="/" className="etef-nav-link" onClick={closeMenu}>
                Accueil
              </Link>
            </li>
            <li className="etef-nav-item">
              <Link to="/a-propos" className="etef-nav-link" onClick={closeMenu}>
                Comment ça marche
              </Link>
            </li>
            <li className={`etef-nav-item etef-services-item ${isServicesOpen ? 'mobile-open' : ''}`}>
              <button className="etef-services-link" onClick={toggleServices}>
                <FaStar className="etef-services-icon" />
                <span>Services</span>
                <FaChevronDown className="etef-dropdown-arrow" />
              </button>
              <ul className="etef-services-dropdown etef-two-columns">
                <li className="etef-dropdown-item">
                  <Link to="/strategie-seo" className="etef-dropdown-link" onClick={closeMenu}>
                    <FaChartLine className="etef-dropdown-icon" />
                    <span>Stratégie SEO</span>
                  </Link>
                </li>
                <li className="etef-dropdown-item">
                  <Link to="/solutions-ecommerce" className="etef-dropdown-link" onClick={closeMenu}>
                    <FaVideo className="etef-dropdown-icon" />
                    <span>Montage Vidéo & Motion</span>
                  </Link>
                </li>
                <li className="etef-dropdown-item">
                  <Link to="/refonte-site-web" className="etef-dropdown-link" onClick={closeMenu}>
                    <FaSync className="etef-dropdown-icon" />
                    <span>Refonte de site web</span>
                  </Link>
                </li>
                <li className="etef-dropdown-item">
                  <Link to="/marketing-digital" className="etef-dropdown-link" onClick={closeMenu}>
                    <FaBullhorn className="etef-dropdown-icon" />
                    <span>Marketing Digital</span>
                  </Link>
                </li>
                <li className="etef-dropdown-item">
                  <Link to="/developpement-web" className="etef-dropdown-link" onClick={closeMenu}>
                    <FaCode className="etef-dropdown-icon" />
                    <span>Développement Web</span>
                  </Link>
                </li>
                <li className="etef-dropdown-item">
                  <Link to="/developpement-mobile" className="etef-dropdown-link" onClick={closeMenu}>
                    <FaMobileAlt className="etef-dropdown-icon" />
                    <span>Développement Mobile</span>
                  </Link>
                </li>
                <li className="etef-dropdown-item">
                  <Link to="/ia-automatisation" className="etef-dropdown-link" onClick={closeMenu}>
                    <FaRobot className="etef-dropdown-icon" />
                    <span>Automatisation & IA</span>
                  </Link>
                </li>
              </ul>
            </li>
            <li className="etef-nav-item">
              <Link to="/reservation-appel" className="etef-nav-link" onClick={closeMenu}>
                Contact
              </Link>
            </li>
          </ul>
          
          <div className="etef-mobile-cta">
            <Link to="/reservation-appel" className="etef-cta-button" onClick={closeMenu}>
              <FaCalendarAlt className="etef-button-icon" />
              <span className="etef-button-text">Réserver un appel</span>
              <FaArrowRight className="etef-button-arrow" />
            </Link>
          </div>
        </nav>
        
        <div className="etef-desktop-cta">
          <Link to="/reservation-appel" className="etef-cta-button">
            <FaCalendarAlt className="etef-button-icon" />
            <span className="etef-button-text">Réserver un appel</span>
            <FaArrowRight className="etef-button-arrow" />
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;